import React from 'react';
import { Bell, Package, Trash2 } from 'lucide-react';
import axios from 'axios';
import { API } from '@/api';
import { formatApiError } from '../../utils/apiError';
import { createTextPicker } from '../../utils/localizedContent';


export default function AdminStockNotifications({ notifications, setNotifications, lang, setMessage }) {
  const l = createTextPicker(lang);

  const handleDeleteAll = async (productId, productName) => {
    if (!window.confirm(l(`¿Borrar todos los avisos de "${productName}"?`, `Clear all alerts for "${productName}"?`))) return;
    try {
      await axios.delete(`${API}/admin/stock-notifications/${productId}`);
      setNotifications && setNotifications(prev => prev.filter(n => n.product_id !== productId));
      setMessage(l('Avisos eliminados', 'Alerts cleared'));
    } catch (err) { setMessage(formatApiError(err)); }
  };

  return (
    <div>
      <h2 className="text-white font-bold text-xl mb-2">{l('Lista de espera — Avísame', '"Notify Me" Waitlist')}</h2>
      <p className="text-[#A1A1AA] text-sm mb-5">
        {l('Usuarios esperando que haya stock de estos productos.', 'Users waiting for these products to be back in stock.')}
      </p>
      {notifications.length === 0 ? (
        <div className="text-center py-10 text-[#52525B]">
          <Bell size={32} className="mx-auto mb-2 opacity-30" />
          <p className="text-sm">{l('No hay nadie en lista de espera', 'No one on the waitlist')}</p>
        </div>
      ) : (
        <div className="space-y-4">
          {notifications.map(n => (
            <div key={n.product_id} className="bg-[#12121A] border border-white/5 rounded-xl p-4">
              <div className="flex items-center gap-3 mb-3">
                <Package size={16} className="text-[#C9A962]" />
                <div className="flex-1">
                  <p className="text-white font-semibold">{n.product_name}</p>
                  <p className="text-[#52525B] text-xs">
                    {l('Stock actual:', 'Current stock:')} {n.current_stock}
                    {' · '}{n.subscribers.length} {l('en espera', 'waiting')}
                  </p>
                </div>
                <span className="px-2 py-0.5 bg-[#F59E0B]/20 text-[#F59E0B] rounded-full text-xs font-semibold">
                  {n.subscribers.length} {l('usuario(s)', 'user(s)')}
                </span>
                <button
                  onClick={() => handleDeleteAll(n.product_id, n.product_name)}
                  className="p-1.5 rounded-lg text-[#EF4444] hover:bg-red-500/10 flex-shrink-0"
                  title={l('Borrar todos los avisos', 'Clear all alerts')}
                >
                  <Trash2 size={14} />
                </button>
              </div>
              <div className="flex flex-wrap gap-1.5">
                {n.subscribers.map(s => (
                  <span key={s.user_id} className="px-2 py-0.5 bg-white/5 text-[#A1A1AA] rounded-full text-xs">
                    {s.user_name}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
